<template>
  <div v-show="visible">
    <bm-form ref="form" lazy-validation>
      <slot />
    </bm-form>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import type { WizardRegistry, WizardStepHandle } from "./useWizardRegistry";

interface BmWizardStepProps {
  registry: WizardRegistry;
  order: number;
  title: string;
  description?: string;
  optional: boolean;
  enabled?: boolean;
}

const props = withDefaults(defineProps<BmWizardStepProps>(), {
  description: "",
  enabled: true,
});

const form = ref<{ validate(): boolean; focus(): void } | null>(null);

const stepHandle: WizardStepHandle = {
  get order() {
    return props.order;
  },
  get title() {
    return props.title;
  },
  get description() {
    return props.description;
  },
  get optional() {
    return props.optional;
  },
  get enabled() {
    return props.enabled;
  },
  validate: () => form.value?.validate() ?? true,
};

const visible = computed(() => props.registry.currentStep === stepHandle);

onMounted(() => {
  props.registry.register(stepHandle);
});

onBeforeUnmount(() => {
  props.registry.unregister(stepHandle);
});

watch(visible, (isVisible) => {
  if (isVisible && form.value) {
    setTimeout(() => form.value?.focus(), 10);
  }
});
</script>
